import React from 'react';
import AdminTabs from '../components/AdminTabs';
import AdminContent from '../components/AdminContent';
import useAdminTab from '../hooks/useAdminTab';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const { tab, filters, goTo } = useAdminTab();

    return (
        <div className="admin-dashboard">
            <div className="admin-shell">
                <header className="admin-shell-header">
                    <div>
                        <h1>Admin</h1>
                        <p className="admin-subtitle">
                            Browse and edit any domain object. Click related fields to jump between tabs.
                        </p>
                    </div>
                </header>
                <AdminTabs activeTab={tab} onChange={(t) => goTo({ tab: t })} />
                <AdminContent tab={tab} filters={filters} goTo={goTo} />
            </div>
        </div>
    );
};

export default AdminDashboard;
